import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type ThemePreference = 'light' | 'dark' | 'system'

interface UiState {
  theme: ThemePreference
  setTheme: (theme: ThemePreference) => void
  commandOpen: boolean
  setCommandOpen: (open: boolean) => void
  mobileNavOpen: boolean
  setMobileNavOpen: (open: boolean) => void
  /** The last step in the location bar on a detail page (a content piece's title), or null. */
  pageCrumb: string | null
  setPageCrumb: (crumb: string | null) => void
}

/** Client-only UI state. Server data lives in TanStack Query, never here. */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => set({ theme }),
      commandOpen: false,
      setCommandOpen: (commandOpen) => set({ commandOpen }),
      mobileNavOpen: false,
      setMobileNavOpen: (mobileNavOpen) => set({ mobileNavOpen }),
      pageCrumb: null,
      setPageCrumb: (pageCrumb) => set({ pageCrumb }),
    }),
    {
      name: 'arvaseo-ui',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ theme: state.theme }),
    },
  ),
)

function systemPrefersDark() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function applyTheme(theme: ThemePreference) {
  const dark = theme === 'dark' || (theme === 'system' && systemPrefersDark())
  document.documentElement.classList.toggle('dark', dark)
}
